"use strict";

var _slicedToArray = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _defineProperty = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _objectSpread = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DurationsContextProvider = exports.DurationsContext = exports.durationReducer = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var durationReducer = function durationReducer(state, action) {
  switch (action.type) {
    case 'got-duration':
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.src, action.durationInSeconds));

    default:
      return state;
  }
};

exports.durationReducer = durationReducer;
exports.DurationsContext = (0, react_1.createContext)({
  durations: {},
  setDurations: function setDurations() {
    throw new Error('context missing');
  }
});

var DurationsContextProvider = function DurationsContextProvider(_ref) {
  var children = _ref.children;

  var _ref2 = (0, react_1.useReducer)(exports.durationReducer, {}),
      _ref3 = _slicedToArray(_ref2, 2),
      durations = _ref3[0],
      setDurations = _ref3[1];

  var value = (0, react_1.useMemo)(function () {
    return {
      durations: durations,
      setDurations: setDurations
    };
  }, [durations]);
  return (0, jsx_runtime_1.jsx)(exports.DurationsContext.Provider, {
    value: value,
    children: children
  });
};

exports.DurationsContextProvider = DurationsContextProvider;